import { PAGE_KEY } from './constants';

export const pt = {
  [PAGE_KEY]: {
    // Mini header (task-06)
    MINI_HEADER_BACK_LABEL: 'Voltar para a lista de conceitos',

    // Meta row (task-06)
    META_CODE_LABEL: 'Código',
    META_TYPE_LABEL: 'Tipo',
    META_CFDI_LABEL: 'CFDI',
    META_RULE_TYPE_LABEL: 'Tipo de regra vigente',

    // Empty states (task-06)
    EMPTY_CONCEPT_NOT_FOUND_TITLE: 'Não encontramos este conceito',
    EMPTY_CONCEPT_NOT_FOUND_DESCRIPTION:
      'O código da URL não corresponde a nenhum conceito do catálogo da sua organização.',
    EMPTY_CONCEPT_NOT_FOUND_ACTION: 'Voltar para a lista',

    // No-access gate state — added by task-06 per the orchestrator's "Gate de la
    // ruta" correction; this is a visibility gate, not a server-verified
    // permission (the authority is the save mutation's UserPermissionErrorResponse,
    // Task 13), so the copy never claims the permission was checked server-side.
    EMPTY_NO_ACCESS_TITLE: 'Você não tem acesso a esta tela',
    EMPTY_NO_ACCESS_DESCRIPTION:
      'O editor de fórmulas está disponível apenas para a equipe de suporte da Crehana.',

    // Error state (task-06)
    ERROR_TITLE: 'Não foi possível carregar o conceito',
    ERROR_RETRY_BUTTON: 'Tentar novamente',

    // Discard dialog (task-07) — o fluxo de descartar ao cancelar se mantém.
    RULES_DISCARD_DIALOG_TITLE: 'Descartar as alterações não salvas?',
    RULES_DISCARD_DIALOG_BODY:
      'Você vai trocar de regra e perder o que escreveu nesta expressão.',
    RULES_DISCARD_DIALOG_CONFIRM: 'Descartar e continuar',

    // AST editor + echo (task-09)
    AST_TEXTAREA_LABEL: 'Expressão da fórmula (AST)',
    AST_TEXTAREA_PLACEHOLDER:
      'Escreva aqui a fórmula em JSON, ou insira uma referência do painel.',
    AST_FORMAT_BUTTON: 'Formatar',
    AST_METRIC_NODES: '{{count}} nós',
    AST_METRIC_DEPTH: 'profundidade {{depth}}/12',
    AST_METRIC_DEPENDENCIES: '{{count}} dependências',
    ECHO_RAW_FALLBACK_HINT:
      'Esta expressão ainda não tem o formato esperado — mostrando o JSON como está.',
    // Defeito 3 (pós-review): texto próprio sobre a mensagem do
    // `JSON.parse`, mantendo a posição (a única pista útil para localizar o
    // erro em um JSON longo).
    AST_JSON_PARSE_ERROR:
      'JSON inválido — verifique o caractere perto da posição {{position}}.',
    // O motor nem sempre informa uma posição (ex. "Unexpected end of JSON
    // input" em um JSON truncado) — nunca deixamos vazar a mensagem crua em
    // inglês nesse caso.
    AST_JSON_PARSE_ERROR_GENERIC:
      'JSON inválido — verifique a sintaxe da expressão.',

    // Validation panel (task-10, -9 chaves no task-08 — AC-8: só renderizam
    // as filas com achados, então nenhuma cópia "tudo certo" tem consumidor).
    VALIDATION_SYNTAX_TITLE: 'Sintaxe',
    VALIDATION_SYNTAX_ERR_HINT: 'Erro de sintaxe em {{path}}',
    VALIDATION_INCOMPLETE_TITLE: 'Fórmula incompleta',
    // AC-7: diferente de Sintaxe — o JSON é válido, faltam apenas dados.
    VALIDATION_INCOMPLETE_HINT: 'Faltam {{count}} valores para completar',
    VALIDATION_REFERENCES_TITLE: 'Referências',
    VALIDATION_REFERENCES_WARN_HINT:
      'Há uma referência válida que ainda não pode ser calculada',
    VALIDATION_REFERENCES_ERR_HINT:
      'Há uma referência que não existe ou está mal escrita',
    VALIDATION_DEPENDENCIES_TITLE: 'Dependências',
    // AC-6: um conceito que termina dependendo de si mesmo.
    VALIDATION_DEPENDENCIES_ERR_HINT:
      'Esta fórmula cria uma dependência circular entre conceitos',
    VALIDATION_DEPTH_TITLE: 'Aninhamento',
    VALIDATION_DEPTH_WARN_HINT:
      'Está próximo do limite de aninhamento ({{depth}}/12)',
    VALIDATION_DEPTH_ERR_HINT: 'Excede o limite de aninhamento ({{depth}}/12)',
    VALIDATION_PCT_TITLE: 'Origem dos dados',
    // AC-8: o backend aceita esta fórmula, por isso é aviso e não bloqueia salvar.
    VALIDATION_PCT_WARN_HINT:
      'Um campo "_pct" não está sendo dividido por 100 — o resultado pode sair 100 vezes maior',

    // Reference panel (task-11)
    REF_PANEL_TITLE: 'Inserir referência',
    REF_PANEL_SEARCH_PLACEHOLDER: 'Buscar por nome do campo…',
    REF_PANEL_GROUP_CONTRACT: 'Contrato',
    REF_PANEL_GROUP_RUN: 'Rodada de folha',
    REF_PANEL_GROUP_ACCUMULATOR: 'Acumulador',
    REF_PANEL_GROUP_FISCAL: 'Fiscal',
    REF_PANEL_GROUP_INCIDENCE: 'Ocorrência',
    REF_PANEL_GROUP_CONCEPT: 'Conceito',
    // AC-9: integration_factor é o único campo desabilitado — está no DSL,
    // mas o port não o serve (UNSERVED_CONTRACT_REF_FIELDS).
    REF_UNSERVED_TOOLTIP:
      'Este campo existe no contrato, mas ainda não está disponível para fórmulas — usá-lo fará o salvamento falhar.',
    // B-4: o subtipo de ref.incidence é sempre "all", nunca editável.
    REF_INCIDENCE_SUBTYPE_TOOLTIP:
      'O subtipo é sempre "all": a captura de ocorrências é texto livre, então fixar um valor específico deixaria de corresponder silenciosamente a qualquer variação de grafia.',

    // ref.contract — 12 campos (CONTRACT_REF_FIELDS)
    REF_CONTRACT_DAILY_WAGE: 'Salário diário',
    REF_CONTRACT_BASE_SALARY: 'Salário base',
    REF_CONTRACT_INTEGRATION_FACTOR: 'Fator de integração',
    REF_CONTRACT_WEEKLY_HOURS: 'Horas semanais',
    REF_CONTRACT_START_DATE: 'Data de admissão',
    REF_CONTRACT_STATE_CODE: 'Estado',
    REF_CONTRACT_VACATION_DAYS: 'Dias de férias',
    REF_CONTRACT_CHRISTMAS_BONUS_DAYS: 'Dias de décimo terceiro',
    REF_CONTRACT_VACATION_PREMIUM_PCT: 'Adicional de férias',
    REF_CONTRACT_SENIORITY_YEARS: 'Anos de antiguidade',
    REF_CONTRACT_PAY_FREQUENCY: 'Frequência de pagamento',
    REF_CONTRACT_IMSS_SALARY_TYPE: 'Tipo de salário IMSS',

    // ref.run — 7 campos (RUN_REF_FIELDS)
    REF_RUN_DAYS_WORKED: 'Dias trabalhados',
    REF_RUN_DAYS_PAID: 'Dias pagos',
    REF_RUN_PERIOD_DAYS: 'Dias do período',
    REF_RUN_PERIOD_START: 'Início do período',
    REF_RUN_PERIOD_END: 'Fim do período',
    REF_RUN_PAYMENT_DATE: 'Data de pagamento',
    REF_RUN_DAYS_BASE: 'Dias base',

    // ref.accumulator — 4 campos (ACCUMULATOR_REF_FIELDS)
    REF_ACCUMULATOR_TAXABLE_INCOME_YTD: 'Renda tributável acumulada',
    REF_ACCUMULATOR_ISR_WITHHELD_YTD: 'ISR retido acumulado',
    REF_ACCUMULATOR_SUBSIDY_APPLIED_YTD: 'Subsídio aplicado acumulado',
    REF_ACCUMULATOR_GROSS_INCOME_YTD: 'Renda bruta acumulada',

    // ref.fiscal — 5 tabelas (FISCAL_REF_TABLES); o campo não tem catálogo (B-5)
    REF_FISCAL_PARAMETERS: 'Parâmetros',
    REF_FISCAL_ISR: 'ISR',
    REF_FISCAL_EMPLOYMENT_SUBSIDY: 'Subsídio ao emprego',
    REF_FISCAL_IMSS_RATE: 'Taxa IMSS',
    REF_FISCAL_ISN_RATE: 'Taxa ISN',

    // ref.incidence — 9 tipos (INCIDENCE_REF_TYPES); os 8 campos aparecem
    // sem tradução (mesmo critério de `ruleType`).
    REF_INCIDENCE_ABSENTEEISM: 'Absenteísmo',
    REF_INCIDENCE_DISABILITY: 'Incapacidade',
    REF_INCIDENCE_OVERTIME: 'Horas extras',
    REF_INCIDENCE_SAVINGS: 'Poupança',
    REF_INCIDENCE_INFONAVIT: 'Infonavit',
    REF_INCIDENCE_FONACOT: 'Fonacot',
    REF_INCIDENCE_PENSION: 'Pensão',
    REF_INCIDENCE_RECURRING: 'Recorrente',
    REF_INCIDENCE_OTHER: 'Outro',

    // Defeito 2 (pós-review): `example` em `concept-ast-catalog.ts` é um
    // exemplo de formato, nunca um valor resolvido de um funcionário real
    // (D-5) — este prefixo evita que seja lido como uma leitura real.
    REF_EXAMPLE_VALUE: 'ex. {{value}}',

    // Unidades (TAstReferenceFieldUnit) — token → texto legível
    UNIT_CURRENCY: 'moeda',
    UNIT_PERCENT: '%',
    UNIT_DAYS: 'dias',
    UNIT_HOURS: 'horas',
    UNIT_DATE: 'data',
    UNIT_CATALOG: 'catálogo',
    UNIT_FACTOR: 'fator',
    UNIT_COUNT: 'contagem',

    // Vista somente leitura para regras que não são FORMULA (task-12, AC-11)
    READONLY_TITLE: 'Esta regra não é editada aqui',
    READONLY_FIXED_DESCRIPTION:
      'É uma regra de valor fixo. Seu valor é exibido apenas como referência.',
    READONLY_MANUAL_INPUT_DESCRIPTION:
      'É uma regra de entrada manual: não há expressão para mostrar.',
    READONLY_TABLE_LOOKUP_DESCRIPTION:
      'É uma regra de tabela de consulta. Sua expressão é exibida apenas como referência.',
    READONLY_NO_EDIT_HINT:
      'O editor de fórmulas só admite regras do tipo FORMULA.',

    // Salvamento / footer / tabela de histórico (task-13)
    BUTTON_CANCEL: 'Cancelar',
    BUTTON_SAVE: 'Salvar regra',
    TOAST_SAVED: 'Regra salva',
    // AC-2 · AC-6: só o título — o corpo é o `message` do backend, textual,
    // nunca reescrito.
    VALIDATION_BACKEND_TITLE: 'Não conseguimos salvar esta regra',
    RULES_HISTORY_TABLE_TITLE: 'Histórico de regras',
    RULES_HISTORY_COLUMN_RULE_TYPE: 'Tipo',
    RULES_HISTORY_COLUMN_PRIORITY: 'Prioridade',
    RULES_HISTORY_COLUMN_VALID_FROM: 'Vigente desde',
    RULES_HISTORY_COLUMN_VALID_TO: 'Vigente até',
    // Não está na lista literal de chaves do task — cobre a excepção de
    // rede / resposta inesperada, o único caso sem `message` do backend (ver
    // o guard `isExpressionInput` e o `catch` de `use-save-concept-rule.ts`).
    SAVE_UNEXPECTED_ERROR: 'Não conseguimos salvar esta regra. Tente de novo.',

    // task-03 — AC-2 grammar
    // Named-function operations (AC-2)
    OP_MAX: 'máx',
    OP_MIN: 'mín',
    OP_ROUND: 'arredondar',
    OP_ABS: 'valor absoluto',
    OP_FLOOR: 'piso',
    OP_CEIL: 'teto',
    OP_ISR_LOOKUP: 'tabela de ISR',
    OP_SUBSIDY_LOOKUP: 'tabela de subsídio ao emprego',
    OP_AND: 'e',
    OP_OR: 'ou',
    OP_NOT: 'não',
    // Special forms
    OP_IF: 'se {{condition}} → {{then}} ; senão → {{else}}',
    OP_GET: '{{target}} → {{field}}',
    OP_DEPENDS_ON: 'depende de: {{list}}',
    // `get(...)` field names
    GET_FIELD_RETENCION: 'retenção',
    GET_FIELD_SUBSIDIO: 'subsídio',
    // ref.fiscal — additive allowlist, NOT a validation catalog (B-10)
    REF_FISCAL_FIELD_UMA_DAILY: 'UMA diária',
    REF_FISCAL_FIELD_EM_EXCEDENTE_3UMA: 'Excedente de 3 UMA',
    REF_FISCAL_FIELD_EM_PRESTACIONES_DINERO: 'Prestações em dinheiro',
    REF_FISCAL_FIELD_EM_GASTOS_MEDICOS_PENSIONADOS:
      'Despesas médicas de aposentados',
    REF_FISCAL_FIELD_IV_PRINCIPAL: 'Invalidez e vida',
    REF_FISCAL_FIELD_RCV_CESANTIA_VEJEZ: 'Aposentadoria, demissão e velhice',
    // ref.incidence fields — closed catalog (B-9)
    REF_INCIDENCE_FIELD_DAYS: 'Dias',
    REF_INCIDENCE_FIELD_TOTAL_HOURS: 'Total de horas',
    REF_INCIDENCE_FIELD_HOURS_FACTOR_50: 'Horas a 50%',
    REF_INCIDENCE_FIELD_HOURS_FACTOR_100: 'Horas a 100%',
    REF_INCIDENCE_FIELD_HOURS_FACTOR_200: 'Horas a 200%',
    REF_INCIDENCE_FIELD_AMOUNT: 'Valor',
    REF_INCIDENCE_FIELD_PERCENTAGE: 'Porcentagem',
    REF_INCIDENCE_FIELD_COUNT: 'Contagem',

    // task-04 — AC-4 sources table
    SOURCES_TITLE: 'De onde vem cada dado',
    SOURCES_COLUMN_DATA: 'Dado',
    SOURCES_COLUMN_ORIGIN: 'Origem',
    SOURCES_COLUMN_PATH: 'Caminho',
    SOURCE_CONCEPT_NO_RULE_TAG: 'Sem regra',
    SOURCE_CONCEPT_NO_RULE_HINT:
      'Este conceito não tem nenhuma regra carregada — não pode ser calculado.',
    SOURCE_ORIGIN_CONTRACT: 'Contrato',
    SOURCE_ORIGIN_RUN: 'Rodada de folha',
    SOURCE_ORIGIN_FISCAL: 'Tabela fiscal',
    SOURCE_ORIGIN_CONCEPT: 'Outro conceito',
    SOURCE_ORIGIN_ACCUMULATOR: 'Acumulador',
    SOURCE_ORIGIN_INCIDENCE: 'Ocorrência',

    // task-05 — AC-2/AC-5 reading card
    READING_TITLE: 'Como se calcula',
    READING_CURRENT_RULE_TAG: 'Vigente desde {{validFrom}}',
    // task-08 (correção de defeito pós-task-07): substitui as chaves
    // `EMPTY_NO_RULE_*` / `EMPTY_NO_CURRENT_RULE_*`, órfãs desde que o
    // `EmptyState` de página inteira foi removido na task-07 — o editor
    // continua acessível, então a chamada para ação vive aqui, não atrás de
    // um bloqueio de página.
    READING_NO_FORMULA:
      'Este conceito ainda não tem uma fórmula. Escreva uma para criar a primeira regra.',

    // task-06 — AC-7 disclosure
    AST_DISCLOSURE_SHOW: 'Ver JSON',
    AST_DISCLOSURE_HIDE: 'Ocultar JSON',
    AST_DISCLOSURE_FINDINGS_BADGE: '{{count}} aviso',
    AST_DISCLOSURE_FINDINGS_BADGE_plural: '{{count}} avisos',

    // task-07 — AC-6 save sequence, AC-5 history marker
    SAVE_ANNOUNCE_TITLE: 'Antes de salvar',
    SAVE_ANNOUNCE_BODY:
      'A nova versão vai valer a partir de hoje ({{today}}) e a anterior vai fechar em {{yesterday}}.',
    SAVE_ANNOUNCE_FIRST_BODY:
      'Esta será a primeira regra do conceito, vigente a partir de hoje ({{today}}).',
    SAVE_HISTORY_NOT_CLOSED_TITLE:
      'A nova regra já calcula, mas o histórico ficou incompleto',
    // Deliberadamente NÃO diz "salve de novo para corrigir": salvar de novo
    // cria uma terceira regra e fecha só a segunda, deixando a original
    // aberta para sempre (memory.md Q-4) — isso não é uma correção real.
    SAVE_HISTORY_NOT_CLOSED_BODY:
      'Não conseguimos fechar a regra anterior. O cálculo já usa a versão nova, mas a anterior continua aberta no histórico.',
    RULES_HISTORY_CURRENT_TAG: 'Vigente',
  },
};
